import { useEffect } from 'react'

import toast from '@/services/lib/toast'

function useSuccess(isSuccess: boolean, message?: string, onCallback?: () => void) {
  useEffect(() => {
    if (isSuccess) {
      if (message && message.trim() !== '') {
        toast.success(message)
      }

      if (onCallback) {
        onCallback()
      }
    }
  }, [isSuccess])
}

export default useSuccess
